// routes
import Router from './routes';
// theme
import ThemeConfig from './theme';
import ThemePrimaryColor from './components/ThemePrimaryColor';
// components
import ScrollToTop from './components/ScrollToTop';
import { UsersProvider } from './contexts/UserContext';
import { AuthProvider } from './contexts/AuthContext'; // Import AuthProvider
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter

// ----------------------------------------------------------------------

export default function App() {
  return (
      <ThemeConfig>
        <ThemePrimaryColor>
          <UsersProvider>
            <AuthProvider> {/* Wrap the whole app with AuthProvider */}
              <ScrollToTop />
              <Router />
            </AuthProvider>
          </UsersProvider>
        </ThemePrimaryColor>
      </ThemeConfig>
  );
}
